import script from "./resetPwd.vue?vue&type=script&setup=true&lang=js"
export * from "./resetPwd.vue?vue&type=script&setup=true&lang=js"

import "./resetPwd.vue?vue&type=style&index=0&id=d5e59730&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5e59730"]])

export default __exports__